<template>
    <div class="announ">
        <div class="title">平台收入</div>
        <div class="warp-block">
           <div class="width-block common-space-between">
               <div class="block common-items-center  projectBlock">
                   <div class="content">
                      <div class="common-space-around">
                        <span  class="number">{{ todayIncome | moneyFromat }}</span>
                      </div>
                      <div class="common-textCenter text">今日收入(元)</div>
                   </div>
               </div>
               <div class="block common-items-center  projectBlock">
                   <div class="content">
                      <div class="common-space-around">
                        <span  class="number">{{ monthIncome | moneyFromat }}</span>
                      </div>
                      <div class="common-textCenter text">本月收入(元)</div>
                   </div>
               </div>
               <div class="block common-items-center  projectBlock">
                   <div class="content">
                      <div class="common-space-around">
                        <span  class="number">{{ totalIncome | moneyFromat }}</span>
                      </div>
                      <div class="common-textCenter text">平台总收入(元)</div>
                   </div>
               </div>
           </div>
        </div>
    </div>
</template>
<script>
import {url,operate} from '@/utils/config'
import {postFun,getFun} from '@/utils/httpFun'
export default {
    components:{
       
    },
    props:{
      width:{
        type:Number,
        default:100
      }  
    },
    data: ()=>({
        monthIncome:0.00,
        todayIncome:0.00,
        totalIncome:0.00
    }),
    mounted() {
        this.getNumber()
    },
    methods:{
        formatter(num){
            return num.toFixed(2);
        },
        getNumber(){
            getFun(operate.INCOMEMONEY,{},res=>{
               this.monthIncome=res.data.monthIncome
               this.todayIncome=res.data.todayIncome
               this.totalIncome=res.data.totalIncome
            })
        }
    },
}
</script>
<style lang="scss" scoped>
    .announ{
        background: #FFFFFF;
        border-radius: 0 10px 0px 0px;
        width:100%;
        padding:20px;
        box-sizing: border-box; 
    }
    .title{
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #323F51;
        font-weight: 600;
        margin-bottom: 20px;
    }
    .warp-block{
        width:100%;
       .width-block{
         width:100%;
         display: flex;
         flex-wrap: wrap;
       }
       .block{
            width:calc(33.333% - 13.333px);
            height: 110px;
            border-radius: 12px;
            cursor: pointer;
        }
        .number{
            font-family: DINAlternate-Bold;
            font-size: 42px;
            font-weight: 700;
            color: #FFFFFF;
        }
        @media screen and (max-Width:1620px) {
            .number{
                font-size: 27px;
            }
        }

        @media screen and (max-Width:1400px) {
            .number{
                font-size: 23px;
            }
        }
        @media screen and (max-Width:1300px) {
            .number{
                font-size: 20px;
            }
        }
        .text{
            font-size: 18px;
            font-weight: 400;
            padding-top:0px;
            color: #FFFFFF;
        }
        .content{
            width: 100%;
        }
    }
    .projectBlock{
        background-image: linear-gradient(180deg, #FFD13D 0%, #FF8048 100%);
    }
</style>
